module.exports = __webpack_public_path__ + "img/landing-soundbar.814fccf6.png";